import { useState, useEffect } from 'react';
import logo from 'assets/logo_login.png';

function useFetchImage(imageUrl) {
  const [imageData, setImageData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    setIsFetching(true);
    setFetchError(false);

    const loadImage = async () => {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);
        setIsFetching(false);
        setImageData(imageUrl)
      } catch (error) {
        console.error('Error fetching image:', error);
        setFetchError(true);
        setIsFetching(false);
        setImageData(logo)
      }
    };

    if (imageUrl) {
      loadImage();
    }

    return () => {
      // Clean up the object URL to prevent memory leaks
      if (imageData) {
        URL.revokeObjectURL(imageData);
      }
    };
  }, [imageUrl]);

  return { imageData, isFetching, fetchError };
}

export default useFetchImage;
